import React from 'react'

import ProjectEmbed from './projectEmbed';
import ProjectEmbed2 from './projectEmbed-2';
import ProjectGif from './projectGif';
import ProjectTiles from './projectTiles';
import ProjectImage from './projectImage';


export default function Works() {
    return (
        <div className='works-container'>
            <div className='intro-main'>
            </div>
            <ProjectEmbed className="project-1" link={"https://www.youtube.com/embed/O3gSusJEGdc"} />
            <ProjectEmbed2 className="project-2" link={"https://www.youtube.com/embed/pviw8Y1QecI"}/>
            <ProjectGif className="project-3" />
            <ProjectImage className="project-4" />
            <ProjectTiles />
        </div>
    )
}

// youtube
// youtube
// gif
// image carousel
// tiles

